<template>
  <div class="links">
    <div class="page-header">
      <v-layout row align-center>
        <v-icon x-large color="primary">mdi-link</v-icon>
        <h1 class="page-title">Links</h1>
      </v-layout>
    </div>
    <div>
      <v-card v-for="link in links" v-bind:key="link.linkId">
        <v-card-title>{{ link.title }}</v-card-title>
        <v-card-subtitle v-if="priviledged">
          Priority: {{ link.priority }} Active: {{ link.active }}
        </v-card-subtitle>
        <v-card-text>{{ link.description }}></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="priviledged"
            outlined
            class="button"
            @click="onEdit(link.linkId)"
          >
            <v-icon left>mdi-pencil</v-icon>Edit
          </v-btn>
          <v-btn
            v-if="priviledged"
            outlined
            class="button"
            @click="onDelete(link.linkId)"
          >
            <v-icon left>mdi-delete</v-icon>Delete
          </v-btn>
          <v-btn
            outlined
            class="button"
            @click="onFollow(link.link)"
          >
            <v-icon left>mdi-link</v-icon>Go
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-if="priviledged">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="priviledged"
            outlined
            class="button"
            @click="onEdit(0)"
          >
            <v-icon left>mdi-plus</v-icon>Add Link
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </div>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline"
            >Delete the selected<br />link?</v-card-title
          >
          <v-card-text>{{ title }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined text @click="dialog = false"
              >No</v-btn
            >
            <v-btn outlined text @click="deleteLink"
              >Yes</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <statusalert ref="alert" returnUrl="/links"></statusalert>
  </div>
</template>

<script>
import LinksService from '../../services/api/LinksService.js'
import store from '@/store/index.js'
import router from '@/router/index.js'
import statusalert from '../../components/StatusAlert'

export default {
  name: 'Links',
  components: {
    statusalert
  },
  store: store,
  data() {
    return {
      dialog: false,
      link: {},
      linkId: 0,
      links: [],
      title: ''
    }
  },

  created() {
    this.fetch()
  },
  computed: {
    priviledged() {
      return (
        this.$store.getters.getAdministrator || this.$store.getters.getProShop
      )
    }
  },
  methods: {
    fetch() {
      store.commit('isLoading')

      LinksService.get()
        .then(links => {
          this.links = links
          this.sort()
          this.filter()
        })
        .catch(error => console.log(error))
        .finally(() => {
          store.commit('notLoading')
        })
    },

    filter() {
      const links = []
      if (!this.priviledged) {
        for (var i = 0; i < this.links.length; i++) {
          const link = this.links[i]
          if (link.active) {
            links.push(link)
          }
        }
        this.links = links
      }
    },

    onEdit(linkId) {
      router.push('/links/edit/' + linkId)
    },

    onDelete(linkId) {
      this.dialog = true
      // Find the links article
      const link = this.links.find(n => n.linkId === linkId)
      this.title = ''
      this.linkId = 0
      if (link) {
        this.linkId = linkId
        this.title = link.title
      }
    },

    onFollow(url) {
      window.open(url)
    },

    deleteLink() {
      this.dialog = false
      if (this.linkId > 0) {
        store.commit('isLoading')
        LinksService.delete(this.linkId)
          .then(result => {
            this.result = {
              isValid: true,
              statusCode: result.status,
              errors: ['Link deleted']
            }
          })
          .catch(error => {
            console.log(error)
            this.result = {
              isValid: true,
              statusCode: 404,
              errors: ['Failed to delete Link']
            }
          })
          .finally(() => {
            store.commit('notLoading')
            this.$refs.alert.displayResult(this.result)
            this.fetch()
          })
      }
    },

    sort() {
      this.links.sort(function(a, b) {
        if (a.active === b.active) {
          return a.priority < b.priority ? -1 : a.priority > b.priority ? 1 : 0
        } else {
          return a.active > b.active ? -1 : 1
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.v-card {
  margin-bottom: 15px;
}
</style>
